export const USER_AUTH_STATUS = "USER_AUTH_STATUS"